import BaseCustomControl from "components/Map/Controls/CustomControls/BaseCustomControl";
import MapContext from "components/Map/MapContext";
import React, { useContext, useEffect, useRef } from "react";

import { Geolocation, Overlay } from "ol";
import * as ol from "ol";
import { Vector as SourceVector } from "ol/source";
import { Style, Icon } from "ol/style";
import Point from "ol/geom/Point";
import VectorLayer from "ol/layer/Vector";
import IconAnchorUnits from "ol/style/IconAnchorUnits";
interface Props {
    title: string;
    handleClick?: () => void;
    myPositionMarkerIconUrl: string;
    active?: boolean;
}

const CenterUserControl: React.FC<Props> = ({
    title,
    handleClick,
    myPositionMarkerIconUrl,
    active = false,
}) => {
    const { map } = useContext(MapContext);
    const previousMarkerRef = useRef<Overlay | null>(null)
    const previousVectorLayerRef = useRef<VectorLayer | null>(null)
    const geolocationRef = useRef<Geolocation | null>(null)

    useEffect(() => {
        return () => {
            geolocationRef.current?.setTracking(false);
            geolocationRef.current = null;
        };
    }, []);

    useEffect(() => { 
        function onPageShow(e:any) {
            if (e.persisted) {
                map?.updateSize();
                geolocationRef.current?.setTracking(false);
                geolocationRef.current = null;
            } else {
                map?.updateSize();
            } 
        }
        function onVisibilityChange() {
            if (!document.hidden) {
                map?.updateSize(); }
            }
                window.addEventListener('pageshow', onPageShow);
                document.addEventListener('visibilitychange', onVisibilityChange);

        return () => { 
            window.removeEventListener('pageshow', onPageShow);
            document.removeEventListener('visibilitychange', onVisibilityChange);
    }; }, [map]);

    function handleMyLocation() {
            if (!map) return;
            map.updateSize();
            geolocationRef.current?.setTracking(false);

            const geol = new Geolocation({
                tracking: false,
                projection: map.getView().getProjection(),
                trackingOptions:
                { 
                    enableHighAccuracy: true,
                    maximumAge: 0,
                    timeout: 15000,  
        
            }, });
            
            geolocationRef.current = geol;
                if (previousVectorLayerRef.current)
                    { map.removeLayer(previousVectorLayerRef.current);
                        previousVectorLayerRef.current = null;
                    }
                    const iconFeature = new ol.Feature({ geometry: new Point([0, 0]), name: 'My Position', });

                    iconFeature.setStyle(
                        new Style({ 
                            image: new Icon({ 
                                src: myPositionMarkerIconUrl,
                                anchor: [0.5, 40],
                                anchorXUnits: IconAnchorUnits.FRACTION, anchorYUnits: IconAnchorUnits.PIXELS, }),
                            })
                        );

                    const layerSource = new SourceVector({ features: [iconFeature] });
                    const vectorLayer = new VectorLayer({ source: layerSource });

                    map.addLayer(vectorLayer);
                    previousVectorLayerRef.current = vectorLayer;


                    geol.on('error', (e) => {
                    window.alert('Unable to access your location. Please allow location access in your browser settings.'); });
                    let firstFixTimeout = window.setTimeout(() => { 
                        geol.setTracking(false);
                        window.alert('Taking too long to get your location. Please try again or check your location settings.'); 
                    }, 10000);
                    
                    geol.once('change:position', () => {
                        window.clearTimeout(firstFixTimeout);
                        const position = geol.getPosition();
                        if (!position) return;
                        (iconFeature.getGeometry() as Point).setCoordinates(position);
                        const view = map.getView();

                        view.setCenter(position);
                        view.setZoom(10);
                        });
                    
                    geol.on('change:position', () => {
                        const position = geol.getPosition();
                        if (!position) return;
                        (iconFeature.getGeometry() as Point).setCoordinates(position);
                    });
                    
                    geol.setTracking(true);
                }


    return (
        <BaseCustomControl
            icon="myPosition"
            title={title}
            handleControl={() => {
                if (handleClick) {
                    handleClick();
                }
                handleMyLocation();
            }}
            className="ol-center-user"
            labelPosition="left"
            active={active}
        />
    );
};

export default CenterUserControl;
